import {Checkbox} from '@tickchak/react-share/app';
import {ItemText} from '../../../component/item/Item.css';
import {updateDesignTicket} from '../../../redux/branding/brandingActions';
import type {TFunction} from 'i18next';

export const TICKET_LINK_OPTION_KEY = 'new';
export const ticketLinkOptionsCssStyle = `.ticketLinkOptionsList{${ItemText}{padding-inline-start: 10px}}`;

interface GetTicketLinkOptionsListParams {
    useNewTicketLink?: number;
    t: TFunction;
}

export function getTicketLinkListItem({useNewTicketLink = 0, t}: GetTicketLinkOptionsListParams) {
    const isNewLink = (useNewTicketLink ?? 0) === 1;
    const label = t('newTicketLinkOption');

    return {
        text: label,
        key: TICKET_LINK_OPTION_KEY,
        rightChildren: (
            <Checkbox checked={isNewLink} ariaLabel={label} />
        ),
        onClick: () => {
            updateDesignTicket({newTicketLink: isNewLink ? 0 : 1});
        },
    };
}

function getTicketLinkOptionsList(params: GetTicketLinkOptionsListParams) {
    const item = getTicketLinkListItem(params);

    return {
        list: [item],
        title: params.t('ticketLinkType'),
        onClick: item.onClick,
        classes: 'ticketLinkOptionsList',
    };
}

export default getTicketLinkOptionsList;
